export const stripHtmlFromStringIfEmpty = (html: string) => {
    const div = document.createElement('div');
    div.innerHTML = html;
    // If there is no text pass empty string
    return div.textContent?.trim() ? html : '';
};
